import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { DHeaderComponent } from './shared/components/d-header/d-header.component';
import { DFooterComponent } from './shared/components/d-footer/d-footer.component';
import { HttpClientModule, HttpParams } from '@angular/common/http';
import { UtilsService } from './services/utils.service';
import { environment } from '../environments/environment';
import { CookieService} from 'ngx-cookie';
import { WindowRefService } from './services/window-ref.service';
import alloy from '@alloyidentity/web-sdk';

const urlConvertorObject: {[key: string]: string} = {
  SAMLRequest: `${environment.oauth.issuer}/saml/route`,
  client_id : `${environment.oauth.issuer}/route`,
  default : "No Values found"
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, DHeaderComponent, DFooterComponent, HttpClientModule],
  providers: [CookieService],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})


export class AppComponent implements OnInit {
  
  constructor(
    private route: ActivatedRoute,
    private utilsSrv: UtilsService,
    private cookieService: CookieService,
    private windowRef: WindowRefService,
  ) {

  }

  title = 'sparkUI';
  userName: string | null = null;
  isrisk = false;  
  allParams: { [key: string]: string } = {};
  tmx_session: any;

  ngOnInit(): void {
    this.userName = localStorage.getItem('email') || null;

    // reading params trough URL 
    this.route.queryParamMap.subscribe((params) => {
      if (params.has('error')) {
        this.isrisk = true;
        // Remove the 'error' parameter from the params map
        const newParams = { ...this.allParams };
        delete newParams['error'];
        this.allParams = newParams;
      }
      params.keys.forEach((key) => {
        if (key !== 'error') {
          this.allParams[key] = params.get(key) || '';
        }        
      });      
    const alloyInitParams = {
      key: '6df6e292-ef03-4958-b4e9-479de46c6073',
      //journeyToken: 'J-jGDtTH0cYoVh2vyVnnjG'
    };
    alloy
      .init(alloyInitParams)
      .then((response) => {
        this.tmx_session = response['threatmetrixSessionId'];
        const userNameExists = localStorage.getItem('email') || null;
        console.log('userNameExists')
        console.log(userNameExists)
        if(userNameExists) {
          this.signInComp(userNameExists);
        }        
      })
      .catch((error) => {
        console.error(error);
      });       
    });    


   

  }


  signInComp(email: string | null = null) {  
      
    const userName = email || '';
      this.allParams['login_hint'] = userName;
      this.allParams['tmx_session'] = this.tmx_session;
      let parameter = new HttpParams();
      console.log('this.allParams');
      console.log(this.allParams);
      let keyVal = 'default';
      for (const key in this.allParams) {
        if (this.allParams.hasOwnProperty(key)) {
          parameter = parameter.set(key, this.allParams[key]);
        }
        if(key in urlConvertorObject){
          keyVal = key;
        }
      }
      console.log(this.allParams['client_id'])
      if(!this.allParams['client_id']) return
      const externalUrl = urlConvertorObject["client_id"];
      console.log(externalUrl);
      const urlWithParams = `${externalUrl}?${parameter.toString()}`;
      console.log(urlWithParams);
      this.cookieService.put('tmx_session', this.allParams['tmx_session'], {expires: this.utilsSrv.daysNow(1)});
      this.cookieService.put('urlWithParams', urlWithParams, {expires: this.utilsSrv.daysNow(1)});
      console.log(userName)
      this.cookieService.put('login_hint', decodeURIComponent(userName),{domain:'.day1cloud.com', storeUnencoded: true} /* 1, '/', '.day1cloud.com' */);       

      // step:1 store email
      localStorage.setItem('email', userName);
      
      this.windowRef.open(urlWithParams, '_self');
    
  }  


}
